import { apiUrl, performApiRequest } from '@/infrastructure/api-requests';
import { GetProjectsByBaseProjectNumberQuery, Project } from './types';

export function getProjectsByBaseProjectNumber(query: GetProjectsByBaseProjectNumberQuery): Promise<Project[]> {
  const url = `${apiUrl}/api/project-search/get-projects-by-base-project-number-query`;
  return performApiRequest<Project[]>({ url, method: 'POST', data: query });
}
